import React, { useEffect, useRef } from 'react';
import { message, Input, Modal, Typography, Button } from 'antd';
import { UserOutlined, ClockCircleOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const ModalPausarVenta = ({ isModalPausarOpen, setIsModalPausarOpen, nombreReferenciaPausar, setNombreReferenciaPausar, ejecutarGuardadoEnEspera, isGuardando }) => {
    
    const inputRef = useRef(null);

    useEffect(() => {
        if (isModalPausarOpen) {
            setTimeout(() => {
                inputRef.current?.focus();
            }, 100);
        }
    }, [isModalPausarOpen]);

    const handleGuardar = () => {
        if (!nombreReferenciaPausar.trim()) {
            return message.warning("Por favor, ingresa un nombre para identificar la venta");
        }
        ejecutarGuardadoEnEspera(nombreReferenciaPausar);
    };

    return (
        <Modal
            title={null}
            open={isModalPausarOpen}
            onCancel={() => setIsModalPausarOpen(false)}
            footer={null}
            centered
            width={500}
            closable={false}
            styles={{
                body: { padding: '24px' },
                mask: {
                    backgroundColor: 'rgba(15, 23, 42, 0.85)',
                    backdropFilter: 'blur(4px)',
                    WebkitBackdropFilter: 'blur(4px)'
                }
            }}
        >
            <div style={{ textAlign: 'center', marginBottom: '24px' }}>
                <div style={{ background: '#fef3c7', width: '64px', height: '64px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
                    <ClockCircleOutlined style={{ fontSize: '32px', color: '#d97706' }} />
                </div>
                <Title level={4} style={{ margin: 0, color: '#0f172a', fontWeight: '900', fontSize: '22px' }}>
                    Pausar Venta
                </Title>
                <Text type="secondary" style={{ fontSize: '15px', marginTop: '8px', display: 'block' }}>
                    Asigna un nombre o mesa para recuperar esta venta más tarde sin perder los productos.
                </Text>
            </div>

            <div style={{ marginBottom: '32px' }}>
                <Input
                    ref={inputRef}
                    placeholder="Ej. Mesa 5, Cliente Juan..."
                    value={nombreReferenciaPausar}
                    onChange={(e) => setNombreReferenciaPausar(e.target.value)}
                    onPressEnter={handleGuardar}
                    prefix={<UserOutlined style={{ color: '#94a3b8', fontSize: '22px', marginRight: '10px' }} />}
                    style={{
                        height: '70px', 
                        fontSize: '22px',
                        fontWeight: '700',
                        borderRadius: '12px',
                        border: '2px solid #cbd5e1',
                        padding: '0 20px'
                    }}
                />
            </div>

            <div style={{ display: 'flex', gap: '16px' }}>
                <Button
                    size="large"
                    onClick={() => setIsModalPausarOpen(false)}
                    style={{
                        flex: 1,
                        height: '65px',
                        borderRadius: '12px',
                        fontSize: '18px',
                        fontWeight: '700',
                        color: '#475569',
                        background: '#f1f5f9',
                        border: '2px solid #cbd5e1'
                    }}
                >
                    Cancelar
                </Button>
                <Button
                    type="primary"
                    size="large"
                    onClick={handleGuardar}
                    loading={isGuardando}
                    disabled={isGuardando}
                    style={{
                        flex: 1,
                        height: '65px',
                        borderRadius: '12px',
                        fontSize: '18px',
                        fontWeight: '800',
                        background: '#f59e0b',
                        borderColor: '#f59e0b',
                        boxShadow: '0 4px 6px -1px rgba(245, 158, 11, 0.2)'
                    }}
                >
                    {isGuardando ? 'Pausando...' : 'Pausar Venta'}
                </Button>
            </div>
        </Modal>
    );
}

export default ModalPausarVenta;